import { Helmet } from 'react-helmet-async';
import ExploreView from 'src/sections/overview/dashboards/views/explore';

export default function SearchPerformanceExplore() {
  return (
    <>
      <Helmet>
        <title>Explore</title>
      </Helmet>

      <ExploreView />
    </>
  );
}
